module.exports = __webpack_public_path__ + "static/splatoon-bg-beec1669f1b3a32d59d8926570af8e76.jpg";